<template>
  <div v-if="term" class="container">
    <LayoutColumns hide-left>
      <template v-slot:main>
        <span class="text-gray-500 lowercase">
          {{ formatDate(new Date(term.LatestUpdate)) }}</span
        >
        <h1 class="headline-m col-span-6 sm:col-span-12">{{ term.Title }}</h1>
      </template>
    </LayoutColumns>
    <LayoutColumns :alignment="'start'" hide-left>
      <template v-slot:main>
        <br />
        <div class="content-dynamic mb-8 md:mb-16">
          <div v-html="term.Body" />
        </div>
      </template>
      <template v-slot:right>
        <div
          v-if="term.Download.data[0].attributes.url"
          class="content-dynamic border-solid border-2 border-gray-50 rounded-xl p-6"
        >
          <h2 class="font-bold">
            {{ $t('Download') }}
          </h2>
          <div class="flex items-start">
            <div class="p-4">
              <component :is="fileIcon" class="fill-current" />
            </div>
            <a :href="term.Download.data[0].attributes.url">
              {{ term.Title }}
            </a>
          </div>
        </div>
      </template>
    </LayoutColumns>
  </div>
</template>

<script setup lang="ts">
import type { StrapiLocale } from '@nuxtjs/strapi'
import fileIcon from '~/assets/icons/file-pdf.svg?component'

const config = useRuntimeConfig()
const route = useRoute()
const { find } = useStrapi()

type Term = {
  Title: string
  Body: string
  LatestUpdate: string
  Slug: string
  Download: {
    data: {
      attributes: {
        url: string
      }
    }[]
  }
}

const { data: term } = await useAsyncData(async () => {
  const termId = route.params.termId
  if (typeof termId !== 'string') return

  const terms = await find<Term>('terms', {
    locale: config.public.site.strapilocale as StrapiLocale,
    populate: '*',
  })

  return terms.data.find((t) => t.attributes.Slug === termId)?.attributes
})

useHead({
  title: term.value?.Title,
})
</script>
